<template>    
    <BaseModal
        :id="'static-update-status'"
        :title="title"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_update()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div class="modal__buttons text-center text-md-right">
                    <button type="button" class="modal__buttons__item cancel" data-dismiss="modal" aria-label="Close" v-html="'Cancel'"/>
                    <button class="modal__buttons__item" v-html="`Save`"/>
                 </div>
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'

export default {

    name:   'UpdateModalStatus',
    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'single_object',
        'global_index',
        "array_options",
        "breadcrumb",
        "ids",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
    },

    data(){
        return {
            form_data:      FormResources.form_data_status,
            form_format:    FormResources.form_format_status,
            form_backup:    {...FormResources.form_data_status},
        }
    },
    
    methods: {
        async form_submit_update()
        {
            const http_request = {
                ids:             this.ids,
                massive_status:  true,
            }
            this.loader(true)
            const response = await this.patch(`${this.rest_api}/${JSON.stringify(http_request)}`, this.form_data)
            this.loader()
            if(response.status) {
                this.notyf.success('Success!')
                window.$('#static-update-status').modal('hide')
                this.form_data = {... this.form_backup}
                this.$emit('spliceObject', response.data)
            } else {
                this.error_handling(response)
            }
        },
    },

    mounted(){

    },
    
}
</script>